import script from "./ListLabel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListLabel.vue?vue&type=script&lang=ts&setup=true"

import "./ListLabel.vue?vue&type=style&index=0&id=191b3614&lang=scss&scoped=true"
import "./ListLabel.vue?vue&type=style&index=1&id=191b3614&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-191b3614"]])

export default __exports__